import { render, staticRenderFns } from "./SandboxRequest.vue?vue&type=template&id=7ad2363d&scoped=true"
import script from "./SandboxRequest.vue?vue&type=script&lang=js"
export * from "./SandboxRequest.vue?vue&type=script&lang=js"
import style0 from "./SandboxRequest.vue?vue&type=style&index=0&id=7ad2363d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad2363d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ad2363d')) {
      api.createRecord('7ad2363d', component.options)
    } else {
      api.reload('7ad2363d', component.options)
    }
    module.hot.accept("./SandboxRequest.vue?vue&type=template&id=7ad2363d&scoped=true", function () {
      api.rerender('7ad2363d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/components/SandboxRequest.vue"
export default component.exports